import * as React from 'react';
import { color, space } from '@core-ds/primitives';
import { Text } from '@chakra-ui/react';
import type { Editor } from '@tiptap/core';

const getCharCount = (editor: Editor): number => {
   return editor.storage.characterCount.characters();
}

export const CharacterCount = props => {
   const { minCharacters, maxCharacters, editor } = props;

   const charCount = editor && getCharCount(editor);
   const tooShort = charCount < minCharacters;
   const tooLong = charCount > maxCharacters;
   const charsLeft = props.maxCharacters - charCount;

   let charCountText: string = String(charsLeft);

   let styleProps: Object = { marginTop: `${space[3]}`, position: 'absolute' };

   if (tooShort) {
      /* Translators: %1 -> number of characters; */
      charCountText = _js('%1 too short', minCharacters - charCount);
   } else if (tooLong) {
      /* Translators: %1 -> number of characters; */
      charCountText = _js('%1 too long', Math.abs(charsLeft));
   }

   if (tooLong || tooShort) {
      styleProps = { ...styleProps, fontWeight: 'bold', color: color.red[600] };
   }

   return <Text {...styleProps}>{charCountText}</Text>;
};
